import { submitArtworkSourceSchema } from "./contestV2/schemas.mjs";
import { localizedStringSchema } from "./shared/localizedString.mjs";
import { safetyScoreSchema } from "./shared/safetyScore.mjs";
import { activeDecorationSchema, membershipSchema } from "./userBase.mjs";
import { z } from "zod";
//#region src/api/orpc/artworkItem.ts
const artworkVisibilitySchema = z.enum(["PUBLIC", "PRIVATE"]);
const artworkSchema = z.object({
	id: z.string(),
	mediaId: z.string(),
	title: z.string().nullable(),
	authorId: z.string().nullable(),
	authorName: z.string().nullable(),
	prompts: z.string(),
	hidePrompts: z.boolean(),
	isPrivate: z.boolean().meta({
		deprecated: true,
		description: "Use `visibility` instead."
	}),
	visibility: artworkVisibilitySchema,
	isSensitive: z.boolean(),
	type: z.string().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime()
});
const artworkListItemAuthorSchema = z.object({
	id: z.string(),
	username: z.string(),
	displayName: z.string(),
	avatarMediaId: z.string(),
	avatarUrl: z.string().url().nullable(),
	membership: membershipSchema.nullable(),
	activeDecorations: z.array(activeDecorationSchema).meta({
		deprecated: true,
		description: "Always returns []. Use `activeDecorationIds` and hydrate via `GET /v2/decoration/batch`."
	}),
	activeDecorationIds: z.array(z.string())
});
const artworkListItemMediaSchema = z.object({
	width: z.number().int().nullable(),
	height: z.number().int().nullable(),
	thumbnailUrl: z.string().url().nullable(),
	publicUrl: z.string().url().nullable()
});
const artworkContestEntrySchema = z.object({
	rank: z.number().int().nullable(),
	prizeAmount: z.number().int(),
	source: submitArtworkSourceSchema,
	submittedAt: z.iso.datetime()
});
const artworkContestSchema = z.object({
	id: z.string(),
	slug: z.string(),
	mediaId: z.string(),
	title: localizedStringSchema,
	entry: artworkContestEntrySchema.nullable()
});
const artworkModerationLabelSchema = z.enum(["blurred", "sensitive"]);
const artworkModerationFlagSchema = z.object({
	isSensitive: z.boolean(),
	isMinors: z.boolean(),
	shouldBlur: z.boolean()
});
const feedMetadataSchema = z.object({ retrieverId: z.string() });
const artworkDebugInfoSchema = z.object({
	paidCredit: z.number().int().nonnegative().nullable(),
	aesScore: z.number().nullable(),
	textSafetyScore: safetyScoreSchema.nullable(),
	mediaSafetyScore: safetyScoreSchema.nullable()
});
const artworkListItemSchema = artworkSchema.extend({
	likedCount: z.number().int(),
	liked: z.boolean(),
	commentCount: z.number().int(),
	author: artworkListItemAuthorSchema.nullable(),
	media: artworkListItemMediaSchema.nullable(),
	imageBlurHash: z.string().nullable(),
	faceCenter: z.object({
		x: z.number(),
		y: z.number()
	}).nullable(),
	videoMediaId: z.string().nullable(),
	tackIds: z.array(z.string()),
	contest: artworkContestSchema.nullable(),
	moderation: z.array(artworkModerationLabelSchema),
	flag: artworkModerationFlagSchema.meta({
		deprecated: true,
		description: "Use `moderation` instead."
	}),
	debugInfo: artworkDebugInfoSchema.nullable()
});
//#endregion
export { artworkContestEntrySchema, artworkContestSchema, artworkDebugInfoSchema, artworkListItemAuthorSchema, artworkListItemMediaSchema, artworkListItemSchema, artworkModerationFlagSchema, artworkModerationLabelSchema, artworkSchema, artworkVisibilitySchema, feedMetadataSchema };
